import { ChildComponents } from '../../DnDChildComponents';
import { useSelector } from 'react-redux';

function Product_1({ customization, imgObj, productWidth }) {
  const imageHashMap = useSelector(state => state.themeSlice?.imageHashMap);

  return (
    <div style={{ width: productWidth + '%', padding: customization?.padding }}>
      <div
        className="height-auto-info border-box-new relative overflow-hidden  h-full flex flex-col"
        style={{
          borderWidth: 1,
          borderColor: customization?.borderColor,
          borderRadius: customization?.borderRadius,
          padding: customization?.betweenProductAndBorderPadding,
          boxShadow: ChildComponents[customization?.boxShadow]?.data,
        }}
      >
        <div
          className="shrink-0"
          style={{
            height: customization?.productImageHeight,
            padding: customization?.productImagePadding,
            backgroundColor:
              customization?.productBackgroundType === 'productBackgroundColor'
                ? customization?.productBackgroundColor
                : '',
            backgroundImage:
              customization?.productBackgroundType === 'productBackgroundImage'
                ? `url(${customization?.productBackgroundImage})`
                : '',
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
            position: 'relative',
          }}
        >
          {imgObj?.image?.type === 'video' ? (
            <video
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
              autoPlay
              muted
              playsInline
              loop
              src={imgObj?.image?.src}
            ></video>
          ) : (
            <img
              loading="lazy"
              src={imgObj?.useCustomImage ? imgObj?.image?.src : imageHashMap[imgObj?.id]?.image}
              className="widgets-ratio-1 h-full w-full"
              alt=""
              style={{
                objectFit: customization?.backgroundSize,
                borderRadius: customization?.productImageBorderRadius,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Product_1;
